module.exports = __webpack_public_path__ + "static/img/number_04@2x.76c5625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/number_04@2x.png
// module id = eHSe
// module chunks = 0